import { useInternet } from "../../../../../hooks/useInternet.js";
import React, { useCallback, useEffect } from "react";
import { SubmitButton } from "../../../../../components/fields/submitButton.jsx";
import { useDropzone } from "react-dropzone";
import { HOST } from "../../../../../hooks/constants.js";
import { useDispatch, useSelector } from "react-redux";
import { zodResolver } from "@hookform/resolvers/zod";
import { SimpleField } from "../../../../../components/fields/simpleField.jsx";
import * as zod from "zod";
import { useForm } from "react-hook-form";
import countries from "i18n-iso-countries";
import i18n_iso_countries from "i18n-iso-countries/langs/en.json";
import { sessionSlice } from "../../../../../slices/sessionSlice.jsx";
import { useResource } from "../../../../../hooks/useResource.js";
import { Button } from "../../../../../components/button";

export function SettingsCompanyPage() {
  let internet = useInternet();

  let session = useSelector((state) => state.session);
  let dispatch = useDispatch();
  let { control, handleSubmit, reset, formState, watch, setValue } = useForm({
    resolver: zodResolver(
      zod.object({
        logo: zod.number().nullish(),
        companyName: zod.string().min(1),
        companyStreet: zod.string().nullish(),
        companyNumber: zod.string().nullish(),
        companyZip: zod.string().nullish(),
        companyCity: zod.string().nullish(),
        companyCountry: zod.string().nullish(),
        companyPhone: zod.string().nullish(),
        companyVat: zod.string().nullish(),
        companyBank: zod.string().nullish(),
      })
    ),
    defaultValues: session.account,
  });
  countries.registerLocale(i18n_iso_countries);

  const onDrop = useCallback(
    async (files) => {
      let data = new FormData();
      for (let file of files) data.append("files", file);
      internet.post("/uploads", data).then(async (res) => {
        let uploads = await res.json();
        setValue("logo", uploads[0].id, { shouldDirty: true });
      });
    },
    [internet, setValue]
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });
  let accountService = useResource("accounts");

  useEffect(() => {
    accountService.get("me").then(() => {
      reset({}, { keepValues: true });
    });
  }, []);

  let save = (d) => {
    return accountService.edit("me", d).then((data) => {
      dispatch(sessionSlice.actions.setData({ ...session, account: data }));
      reset({}, { keepValues: true });
    });
  };
  return (
    <div className={"flex flex-col gap-3 p-3"}>
      {" "}
      <div className={"flex"}>
        <h2 className={"font-bold py-2 flex items-center flex-grow"}>
          Company
        </h2>
      </div>
      <form
        onSubmit={handleSubmit(save)}
        className={"flex flex-col gap-3"}
        style={{ maxWidth: 500 }}
      >
        <p>
          Please provide your company details here. This information will be
          visible on the documents you create for your customers.
        </p>

        <div className={"flex flex-col gap-2"}>
          <div className={"font-medium"}>Logo</div>
          <div
            {...getRootProps()}
            className={
              "border border-gray-400 p-3 border-dashed bg-white hover:bg-blue-50 cursor-pointer flex flex-col gap-3 rounded"
            }
          >
            <input {...getInputProps()} />
            <p>Upload your company logo</p>

            {watch("logo") && (
              <div style={{ width: 200 }}>
                <img
                  src={`${HOST}/uploads/${watch("logo")}/download?token=${
                    window.localStorage.token
                  }`}
                />
              </div>
            )}
          </div>
        </div>
        <SimpleField
          name={"companyName"}
          label={"Company Name"}
          control={control}
        />
        <div className={"flex gap-3"}>
          <div className={"flex-grow"}>
            <SimpleField
              name={"companyStreet"}
              label={"Street"}
              control={control}
            />
          </div>
          <div style={{ width: 150 }}>
            <SimpleField
              name={"companyNumber"}
              label={"Number"}
              control={control}
            />
          </div>
        </div>
        <div className={"flex gap-3"}>
          <div className={"flex-grow basis-0"}>
            <SimpleField name={"companyZip"} label={"Zip"} control={control} />
          </div>
          <div className={"flex-grow basis-0"}>
            <SimpleField
              name={"companyCity"}
              label={"City"}
              control={control}
            />
          </div>
          <div className={"flex-grow basis-0"}>
            <SimpleField
              name={"companyCountry"}
              label={"Country"}
              control={control}
              type={"select"}
              select={{
                options: Object.entries(countries.getNames("en")).map(
                  ([value, label]) => {
                    return {
                      value,
                      label,
                    };
                  }
                ),
              }}
            />
          </div>
        </div>
        <SimpleField name={"companyPhone"} label={"Phone"} control={control} />
        <SimpleField
          name={"companyVat"}
          label={"VAT Number"}
          control={control}
        />
        <SubmitButton formState={formState} type={"submit"}>
          Save
        </SubmitButton>
      </form>
    </div>
  );
}
